import React from 'react';
import { Button } from '../ui/button';
import { Link } from 'react-router-dom';
import BlogSectionCard from './BlogSectionCard';
import { BlogPost } from '@/services/blogService';

interface BlogSectionGridProps {
  posts: BlogPost[];
  isVisible: boolean;
}

const BlogSectionGrid: React.FC<BlogSectionGridProps> = ({ 
  posts, 
  isVisible
}) => {
  return (
    <>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 sm:gap-8">
        {posts.map((post, index) => (
          <BlogSectionCard
            key={post.id}
            post={post}
            index={index}
            isVisible={isVisible}
          />
        ))}
      </div>
      
      <div className={`mt-8 sm:mt-12 text-center transition-all duration-500 delay-[800ms] ${
        isVisible ? 'opacity-100 translate-y-0 fade-up' : 'opacity-0 translate-y-8'
      }`}>
        <Button asChild variant="outline" size="lg" className="hover:scale-105 transition-transform">
          <Link to="/blog" className="flex items-center gap-2">
            Read All Articles
          </Link>
        </Button>
      </div>
    </>
  );
};

export default BlogSectionGrid;
